import { Box,Circle,Text } from "@chakra-ui/react";
import { ReactComponent as CoursesIcon } from '../../svg/book.svg'
import { ReactComponent as Hourglass } from '../../svg/hourglass.svg'
import { ReactComponent as Announcements } from '../../svg/bullhorn.svg'
import { ReactComponent as Schedule } from '../../svg/schedule.svg';
import { ReactComponent as Courses } from "../../svg/book.svg";

export default function StudentStatistics({ statistics }) {
    return (
       <Box
            w='100%'
            d='flex'
            flexDir='column'
            mb='1.5rem'
        >
            

            <Box
                w='100%'
                d='flex'
                justifyContent='space-between'
                flexWrap='wrap'
                style={{ gap: '0.5rem' }}
            >
            <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Courses width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of library items
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_library_items}
                                </Text>
                        
                    </Box>
                </Box>

                 <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Courses width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of library videos
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_library_videos}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Courses width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of library books
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_library_books}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Courses width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of library documents
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_library_documents}
                                </Text>
                        
                    </Box>
                </Box>

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#3A7DFD1A' mr='1rem'>
                        <Box
                            d='flex'
                            width='24px'
                            height='24px'
                            justifyContent='space-between'
                            alignItems='center'
                            flexWrap='wrap'
                        >
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                border='1px solid #3A7DFD'
                            ></Box>
                        </Box>
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of pass
                        </Text>
                        
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >{statistics.no_of_pass}
                                </Text>
                        
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#FD5F3A1A' mr='1rem'>
                        <CoursesIcon width='25px' height='25px' fill='#fd5f3a' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of  fail
                        </Text>
                        
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >{statistics.no_of_fail}
                                </Text>
                        
                    </Box>
                </Box>

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#42C9781A' mr='1rem'>
                        <Hourglass width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                           Total Marks
                        </Text>
                            <Text
                                fontSize='24px'
                                fontWeight='800'
                                color='#000000'
                            > {statistics.total_marks}
                               
                            </Text>
                        
                    </Box>
                </Box>

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Announcements width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of announcements
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_announcements}
                                </Text>
                        
                    </Box>
                </Box>
               
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Schedule width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of class schedules
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_class_schedules}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Schedule width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of exam schedules
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statistics.no_of_exam_schedules}
                                </Text>
                        
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}